import {
    SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO
  } from '../../actions/types';
  
  const initialState = {ida:0.00, volta:0.00}
  
  export default function reducerSelecionarValorAcrescimoPassagemCalculado (state = initialState, action) {
    switch (action.type) {
      case SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO: {
        return action.payload
      }
      default:
        return state
    }
  }
  